export default __webpack_public_path__ + "static/media/1t.346922ba.jpg";